// src/component/PaginaRevista/imagenesRevista.js
function importAll(r) {
  return r.keys().map(r);
}

export const imagenesPosesionCbba = importAll(
  require.context('../../assets/posesionCbba', true, /\.(png|jpe?g|svg)$/)
);